/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".winpro[_ngcontent-%COMP%]{display:flex;margin-top:4em}.winpro__image[_ngcontent-%COMP%]{width:50%;padding:0 2em;text-align:right}.winpro__image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:100%}.winpro__result[_ngcontent-%COMP%]{width:50%;padding:0 2em}.winpro__title[_ngcontent-%COMP%]{font-size:1.5em}.winpro__price[_ngcontent-%COMP%]{font-size:2em;margin:.5em 0 .7em;font-weight:700}"];
export { styles as styles };
